/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect} from 'react'
import {Outlet, Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* Left Container */}
      <div
        className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1 justify-content-center'
        style={{background: 'white'}}
      >
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
        </div>

        <div className='d-flex flex-center flex-wrap px-5'>
          <div className='d-flex fw-semibold text-primary fs-base'>
            {/* <a href='#' className='px-5' target='_blank'>
              Terms
            </a>

            <a href='#' className='px-5' target='_blank'>
              Plans
            </a>

            <a href='#' className='px-5' target='_blank'>
              Contact Us
            </a> */}
          </div>
        </div>
      </div>

      {/* Right Container */}
      <div
        className='d-flex flex-column justify-content-center align-items-center w-100 w-lg-50 order-1 order-lg-2 right-container py-4 py-lg-5'
        style={{background: '#EFFAFC'}}
      >
        {/* HealthMetrics Logo - Top Section */}
        <div className='d-flex justify-content-center align-items-center mt-3 mt-md-4 px-4 gap-3'>
          <div style={{maxWidth: '320px', width: '100%'}}>
            <a href='https://www.healthmetrics.com'>
              <img
                src={toAbsoluteUrl('/media/misc/hms-logo.png')}
                alt='HealthMetrics'
                className='img-fluid'
              />
            </a>
          </div>
          <div style={{flex: '0 0 auto'}}>
            <img
              src={toAbsoluteUrl('/media/misc/afi.png')}
              alt='AFI Logo'
              style={{height: '90px', width: '90px', borderRadius: '5px'}}
            />
          </div>
        </div>

        <div className='d-flex align-items-center mb-3'>
          <span className='me-2 fs-7 text-muted'>Formerly known as</span>
          <a href='https://www.acrossasiaassist.com/' style={{width: '130px', maxWidth: '100%'}}>
            <img
              src={toAbsoluteUrl('/media/misc/AAA-logo.png')}
              alt='Across Asia Assist'
              className='img-fluid'
            />
          </a>
        </div>

        {/* Dashboard Image - Bottom Section */}
        <div
          className='d-flex justify-content-center align-items-center mt-2 px-3 px-md-4'
          style={{width: '100%'}}
        >
          <div style={{maxWidth: '550px', width: '100%', margin: '0 auto'}}>
            <img
              src={toAbsoluteUrl('/media/misc/hms-dashboard.png')}
              alt='Dashboard'
              className='img-fluid'
              style={{borderRadius: '12px 12px 0 0'}}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export {AuthLayout}
